import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  FaArrowRight,
  FaTrashAlt,
  FaSearch,
  FaStoreAlt,
  FaSave,
} from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";

const RegisterObat = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('role');
  const outletIdLS = localStorage.getItem('id_outlet');
  
  // Master Obat
  const [masterObat, setMasterObat] = useState([]);
  const [metaMasterObat, setMetaMasterObat] = useState({});
  const [paginationMasterObat, setPaginationMasterObat] = useState({
    page: 1,
    search: ""
  })
  const handleChangePaginationMasterObat = (changes) => {
    if (changes.search !== "") {
      changes.page = 1;
    }
    setPaginationMasterObat((prev) => ({
      ...prev,
      ...changes
    }))
  }
  
  // Obat In Outlet
  const [obatInOutlet, setObatInOutlet] = useState([]);
  const [metaObatInOutlet, setMetaObatInOutlet] = useState({})
  const [paginationObatInOutlet, setPaginationObatInOutlet] = useState( {
    page: 1,
    search: ""
  })
  const handleChangePaginationObatInOutlet = (changes) => {
    if (changes.search !== "") {
      changes.page = 1;
    }
    setPaginationObatInOutlet((prev) => ({
      ...prev,
      ...changes
    }))
  }
  
  // Master Outlet
  const [outlets, setOutlets] = useState([]);
  const [metaOutlets, setMetaOutlets] = useState({});
  const [paginationOutlets, setPaginationOutlets] = useState({
    page: 1,
    search: ""
  });
  
  // Other states
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [selectedOutletDetail, setSelectedOutletDetail] = useState({
    id: 0,
    name: ''
  });
  const handleSetSelectedOutlet = (outlet) => {
    setSelectedOutlet(outlet.id);
    setSelectedOutletDetail((prev) => ({
      ...prev,
      ...outlet
    }))
  }
  const [needDelete, setNeedDelete] = useState([]);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [registeredObatInOutlet, setRegisteredObatInOutlet] = useState([])
  const [registeredObatDefault, setRegisteredObatDefault] = useState([])
  const [itemNew, setItemNew] = useState([])
  const [itemDisplay, setItemDisplay] = useState([]);
  const ITEMS_PER_PAGE = 10;
  
  useEffect(() => {
    fetchMasterObat(paginationMasterObat.page, paginationMasterObat.search).then();
  }, [paginationMasterObat]);
  useEffect(() => {
    fetchOutlets(paginationOutlets.page, paginationOutlets.search).then();
  }, [paginationOutlets]);
  useEffect(() => {
    if (selectedOutlet) {
      fetchObatInOutlet(selectedOutlet,paginationObatInOutlet.page).then();
      fetchRegisteredObatInOutlet(selectedOutlet).then();
    }
  }, [selectedOutlet,paginationObatInOutlet]);
  
  useEffect(() => {
    const merged = mergeItems(
      paginationObatInOutlet.page,
      ITEMS_PER_PAGE,
      itemNew,
      obatInOutlet,
      paginationObatInOutlet.search
    );
    setItemDisplay(merged);
  }, [itemNew, obatInOutlet,needDelete, paginationObatInOutlet.page]);
  
  const getTotalPages = (itemNew, meta) => {
    return Math.ceil((itemNew.length + meta.total) / ITEMS_PER_PAGE);
  };
  const getFilteredItems = (localData, apiData, search = "") => {
    const flatApi = apiData.filter(Boolean).flat();
    const mergedAll = [...localData, ...flatApi];
    
    // remove items that are in needDelete
    const filteredDeleted = mergedAll.filter(item => !needDelete.includes(item.id));
    
    // unique by id
    const unique = filteredDeleted.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    );
    
    // filter by search
    return search
      ? unique.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
      : unique;
  };
  // const mergeItems = (page, perPage, localData, apiPages,search = "") => {
  //   const mergedAll = getFilteredItems(localData, apiPages, search);
  //
  //   const start = (page - 1) * perPage;
  //   const end = start + perPage;
  //
  //   return mergedAll.slice(start, end);
  // };
  const mergeItems = (page, perPage, localData, apiPages, search = "") => {
    const flatApi = apiPages.filter(Boolean).flat();
    
    // 1️⃣ filter deleted
    const filteredLocal = localData.filter(i => !needDelete.includes(i.id));
    const filteredApi = flatApi.filter(i => !needDelete.includes(i.id));
    
    // 2️⃣ filter by search
    const matchSearch = (item) =>
      item.name.toLowerCase().includes(search.toLowerCase());
    
    const searchedLocal = search ? filteredLocal.filter(matchSearch) : filteredLocal;
    const searchedApi = search ? filteredApi.filter(matchSearch) : filteredApi;
    
    // 3️⃣ pagination logic
    const start = (page - 1) * perPage;
    const end = start + perPage;
    
    // full local
    if (end <= searchedLocal.length) {
      return searchedLocal.slice(start, end);
    }
    
    // campuran
    if (start < searchedLocal.length && end > searchedLocal.length) {
      const localPart = searchedLocal.slice(start);
      const apiNeeded = perPage - localPart.length;
      const apiPart = searchedApi.slice(0, apiNeeded);
      return [...localPart, ...apiPart];
    }
    
    // full API
    const apiStart = start - searchedLocal.length;
    const apiEnd = apiStart + perPage;
    return searchedApi.slice(apiStart, apiEnd);
  };
    
  const fetchOutlets = async (page = 1, search = "") => {
    try {
      const res = await axios.get(`${API_BASE}/v1/outlet?page=${page}&search=${search}`, { headers });
      setOutlets(res.data.data || []);
    } catch (err) {
      toast.error(err.response.data.message)
    }
  };

  const fetchMasterObat = async (page = 1, search = "") => {
    try {
      const res = await axios.get(`${API_BASE}/v1/drug`, {
        headers,
        params: {
          page,
          per_page: 10,
          search,
        },
      });
  
      const data = res.data.data || [];
      const meta = res.data.meta || { current_page: 1, last_page: 1, total: 0 };
  
      setMasterObat(
        data.map((item) => ({
          id: item.id,
          name: item.name,
          dosis: item.dosis,
          stock: item.stock,
          isi: item.isi,
          expired_at: null,
          isNew: true,
        }))
      );
  
      setMetaMasterObat(meta);
    } catch (err) {
      console.error("Failed to fetch master obat:", err);
    }
  };

  const fetchObatInOutlet = async (outletId,page= 1) => {
    if (!outletId) return;
    try {
      const res = await axios.get(`${API_BASE}/v1/drug?id_outlet=${outletId}&page=${page}&search=${paginationObatInOutlet.search}`, { headers });
      const data = res.data.data || [];
      
      setObatInOutlet((prev) => {
        const newArr = [...prev];
        newArr[page-1] = data.map(item=>({
          id: item.id,
          name: item.name,
          dosis: item.dosis,
          stock: item.stock,
          isi: item.isi,
          expired_at: item.expired_at || null,
          isNew: false,
        }))
        return newArr;
      });
      
      setMetaObatInOutlet(res.data.meta);
    } catch (err) {
      console.error('Failed to fetch outlet obat:', err);
    }
  };
  
  const fetchRegisteredObatInOutlet = async (outletId) => {
    if (!outletId) return;
    try {
      const res = await axios.get(`${API_BASE}/v1/drug/registered/${outletId}`, { headers });
      const data = res.data.data || [];
      setRegisteredObatInOutlet((prev) => {
        const newIds = data.ids.filter((id) => !prev.includes(id));
        return [...prev, ...newIds];
      })
      setRegisteredObatDefault(data.ids || []);
    } catch (err) {
      console.error('Failed to fetch outlet obat:', err);
    }
  }
  
  const handleSubmit = async () => {
    const outletId = userRole === 'manager' ? outletIdLS : selectedOutlet;
  
    if (!outletId) {
      toast.error("Pilih outlet terlebih dahulu sebelum menyimpan.");
      return;
    }
  
    const payload = {
      outlet_id: parseInt(outletId),
      item: itemNew.map((obat) => ({
        drug_id: obat.id,
        stock: parseInt(obat.stock),
        expired_at: obat.expired_at || "2027-09-12",
      })),
      need_delete: needDelete,
    };
  
    console.log("Payload yang dikirim:", JSON.stringify(payload, null, 2)); // Debug log
  
    try {
      const res = await axios.post(`${API_BASE}/v1/drug/registration`, payload, {
        headers,
      });
      if (res.status !== 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
        }).then(() => {
            navigate('/obat-paket/obat');
        })
      }
      setObatInOutlet([]);
      setNeedDelete([]);
    } catch (error) {
      toast.error("Gagal registrasi obat. Silakan coba lagi beberapa meneit lagi.");
    }
  };
  
  const toggleSelect = (id) => {
    if (selectedItem.includes(id)) {
      setSelectedItem((prev) => prev.filter((item) => item !== id));
    } else {
      setSelectedItem((prev) => [...prev, id]);
    }
  };
  
  const addToRight = () => {
    if (!selectedOutlet) {
      toast.error("Pilih outlet tujuan terlebih dahulu sebelum menambahkan obat.");
      return;
    }
    
    if (selectedItem.length === 0) {
      toast.error("Pilih minimal satu obat dari Master Obat.");
    }
  
    const selectedObat = masterObat.filter(
      (obat) => selectedItem.includes(obat.name) && !obat.isDisabled
    );
  
    const newList = selectedObat.map((obat) => ({
      id: obat.id, // Ganti ke drug_id jika perlu
      name: obat.name,
      dosis: obat.dosis,
      stock: obat.stock,
      isi: obat.isi,
      expired_at: obat.expired_at,
      isNew: true,
    }));
    setItemNew((prev)=>{return[...newList,...prev]});
    setRegisteredObatInOutlet((prev)=>{return[...prev,...newList.map(item=>item.id)]})
    setSelectedItem([]);
  };

  const handleAddSingleItem = (itemNew) => {
    if (!selectedOutlet) {
      toast.error("Pilih outlet terlebih dahulu sebelum menambahkan obat.");
      return;
    }
    const newItem = masterObat.find((obat) => obat.id === itemNew.id);
    setRegisteredObatInOutlet((prev)=>{
        if (prev.includes(newItem.id)) {
          return prev;
        } else {
          return [...prev, newItem.id]
        }
    })
    setItemNew((prev) => {
      const exist = prev.find((item) => item.id === newItem.id);
      if (exist) {
        return prev;
      } else {
        return [{
          id: newItem.id,
          name: newItem.name,
          dosis: newItem.dosis,
          stock: newItem.stock,
          isi: newItem.isi,
          expired_at: newItem.expired_at || null,
          isNew: true,
        },...prev]
      }
    })
  };

  const updateMasterDisabledStatus = () => {
    const outletNames = obatInOutlet.map((obat) => obat.name);
    const updated = masterObat.map((obat) => ({
      ...obat,
      isDisabled: outletNames.includes(obat.name),
    }));
    setMasterObat(updated);
  };
  
  const removeFromOutlet = (id) => {
    const exist = registeredObatDefault.includes(id);
    if (!exist) {
      setItemNew((prev) => prev.filter((item) => item.id !== id));
      setRegisteredObatInOutlet((prev) => prev.filter((itemId) => itemId !== id));
      return;
    } else {
      const obatDetail = itemDisplay.find(obat => obat.id === id);
      Swal.fire({
        title: `Are you sure delete ${obatDetail.name}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          setNeedDelete((prev) => [...prev, id]);
          Swal.fire(
            "Deleted!",
            "Your file has been deleted.",
            "success"
          );
        }
      })
      return;
    }
    
    // setNeedDelete((prev) => [...prev, id]);
  };
  const handleChangePage = async (newPage) => {
    if (newPage < 1) return;
    
    const totalNeeded = newPage * ITEMS_PER_PAGE;
    const apiNeeded = totalNeeded > itemNew.length
      ? totalNeeded - itemNew.length
      : 0;
    const apiPageToFetch = Math.ceil(apiNeeded / 10); // page api yang harus ada
    
    if (apiPageToFetch > 0) {
      for (let p = 1; p <= apiPageToFetch; p++) {
        if (!obatInOutlet[p - 1]) {
          await fetchObatInOutlet(selectedOutlet, p);
        }
      }
    }
    
    setPaginationObatInOutlet((prev) => ({ ...prev, page: newPage }));
  };
  
  return (
    <div className="p-6 bg-white rounded-2xl shadow-lg h-full text-gray-700 space-y-3.5 text-sm">
      <div className="text-xs text-gray-500">
        Obat / Obat / Registration Obat to {selectedOutletDetail.name}
        <span className="font-semibold text-gray-800">
          {userRole === 'manager' ? selectedOutlet : ''}
        </span>
      </div>

      <div>
        <h1 className="text-xl font-bold mb-1 text-gray-800">Mapping Obat</h1>
        <p className="text-sm text-gray-500">
          Ensure the Obat from your mapped correctly to Registration Obat
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        
        {/* Master Obat */}
        <div className="w-full lg:w-5/12 bg-white rounded-xl border shadow-sm h-full">
          <div className="px-4 py-3 border-b space-y-2">
            <h2 className="text-base font-semibold text-gray-700">Master Obat</h2>
              <div className="relative">
                <FaSearch className="absolute top-3 left-3 text-gray-400" />
                <input
                  type="text"
                  placeholder="Cari obat..."
                  value={paginationMasterObat.search}
                  onChange={(e) => {
                    handleChangePaginationMasterObat({search:e.target.value});
                  }}
                  className="w-full pl-10 pr-4 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none transition"
                />
              </div>
            </div>
          <div className="bg-gray-50 font-medium p-2 border-b text-xs text-gray-500 uppercase tracking-wider rounded-t-none">Name</div>
          <div className="relative overflow-y-auto h-60">
            {masterObat.map((obat, idx) => (
              <div
                key={idx}
                className={`flex items-center justify-between px-4 py-3 ${
                  registeredObatInOutlet.includes(obat.id) ? "text-gray-300" : "text-gray-700"
                }`}
              >
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    disabled={registeredObatInOutlet.includes(obat.id)}
                    checked={selectedItem.includes(obat.name)}
                    onChange={() => toggleSelect(obat.name)}
                  />
                  <span className="text-sm">
                    {obat.name} {obat.dosis} {obat.stock} {obat.isi} - {obat.expired_at}
                  </span>
                </div>
                {selectedItem.length === 0 && (
                  <button
                    onClick={() => handleAddSingleItem(obat)}
                    disabled={!selectedOutlet || registeredObatInOutlet.includes(obat.id)}
                    className={`text-gray-400 transition ${
                      (!selectedOutlet || registeredObatInOutlet.includes(obat.id)) ? "hover:text-grey-400 opacity-50 cursor-not-allowed" : "hover:text-blue-400"
                    }`}
                    title="Add this item"
                  >
                    <FaArrowRight/>
                  </button>
                )}
              </div>
            ))}
          </div>
          
          {/* ⬅️➡️ Pagination */}
          <div className="flex justify-between items-center mb-4 mt-4 px-4">
            <button
              onClick={() => {
                if (metaMasterObat.current_page > 1) setPaginationMasterObat({page: paginationMasterObat.page - 1});
              }}
              disabled={metaMasterObat.current_page === 1}
              className={`px-3 py-1 rounded ${
                metaMasterObat.current_page === 1 ? "bg-gray-200 text-gray-500 cursor-not-allowed" : "bg-blue-500 text-white"
              }`}
            >
              Previous
            </button>

            <span className="text-sm">
              Page {metaMasterObat.current_page} of {metaMasterObat.last_page}
            </span>

            <button
              onClick={() => {
                if (metaMasterObat.current_page < metaMasterObat.last_page) setPaginationMasterObat({page: paginationMasterObat.page + 1});
              }}
              disabled={metaMasterObat.current_page === metaMasterObat.last_page}
              className={`px-3 py-1 rounded ${
                metaMasterObat.current_page === metaMasterObat.last_page
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Next
            </button>
          </div>
        </div>

        {/* Add to Right button */}
        <div className="w-full lg:w-2/12 flex items-center justify-center">
          <button
            onClick={addToRight}
            className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-5 py-2.5 rounded-xl hover:from-blue-700 hover:to-blue-600 text-sm font-medium shadow-md transition-all flex items-center gap-2"
          >
            Add to Right <FaArrowRight />
          </button>
        </div>

        {/* Obat in Outlet */}
        <div className="w-full lg:w-5/12 bg-white rounded-xl border shadow-sm h-full">
          <div className="px-4 py-3 border-b space-y-2">
            <h2 className="text-base font-semibold text-gray-700">Obat in Outlet</h2>

            {userRole !== 'manager' && (
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1 flex items-center gap-2">
                  <FaStoreAlt /> Pilih Outlet
                </label>
                {!selectedOutlet && (
                  <p className="text-red-500 text-sm mt-1">* Harap pilih outlet sebelum menambahkan obat</p>
                )}

                <select
                  className="w-full p-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  value={selectedOutlet || ''}
                  onChange={(e) => handleSetSelectedOutlet({id: e.target.value, name: e.target.options[e.target.selectedIndex].text})}
                >
                  <option value="">-- Pilih Outlet --</option>
                  {outlets.map((outlet) => (
                    <option key={outlet.id} value={outlet.id}>
                      {outlet.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="relative">
              <FaSearch className="absolute top-3 left-3 text-gray-400" />
              <input
                type="text"
                placeholder="Search for the Obat in Outlet..."
                className="w-full pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                value={paginationObatInOutlet.search}
                onChange={(e) => handleChangePaginationObatInOutlet({search:e.target.value})}
              />
            </div>
          </div>
          <div className="bg-gray-50 font-medium p-2 border-b text-xs text-gray-500 uppercase tracking-wider">Name</div>
          <div className="relative overflow-y-auto h-60">
            {itemDisplay.map((obat, idx) => (
              <div key={idx} className="flex items-center justify-between px-4 py-3">
                <span className="text-sm text-gray-700">
                  {obat.name} {obat.dosis} {obat.stock} {obat.isi} - {obat.expired_at}
                  {obat.isNew && (
                    <span className="text-green-600 ml-2 text-xs font-semibold bg-green-100 px-2 py-0.5 rounded-full">
                      New
                    </span>
                  )}
                </span>
                <button
                  onClick={() => removeFromOutlet(obat.id)}
                  className="text-red-500 hover:text-red-600 transition"
                  title="Remove"
                >
                  <FaTrashAlt size={14} />
                </button>
              </div>
            ))}
          </div>
          
          {/* Pagination drug in outlet */}
          <div className="flex justify-between items-center mb-4 mt-4 px-4">
            <button
              onClick={() => handleChangePage(paginationObatInOutlet.page - 1)}
              disabled={paginationObatInOutlet.page === 1}
              className={`px-3 py-1 rounded ${
                paginationObatInOutlet.page === 1
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Previous
            </button>
            {selectedOutlet ? (
              <span className="text-sm">
                Page {paginationObatInOutlet.page} of {getTotalPages(itemNew, metaObatInOutlet)}
              </span>
            ):(
              <span className="text-sm">
                Page -- of --
              </span>
            )}
            
            <button
              onClick={() => handleChangePage(paginationObatInOutlet.page + 1)}
              disabled={
                !selectedOutlet ||
                paginationObatInOutlet.page >= getTotalPages(itemNew,metaObatInOutlet)
              }
              className={`px-3 py-1 rounded ${
                (
                    !selectedOutlet ||
                    paginationObatInOutlet.page >= getTotalPages(itemNew,metaObatInOutlet)
                )? "bg-gray-200 text-gray-500 cursor-not-allowed" : "bg-blue-500 text-white"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="pt-4 flex justify-end">
        <button
          onClick={handleSubmit}
          className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-6 py-2.5 rounded-2xl text-xs font-bold shadow-lg shadow-emerald-600/20 flex items-center gap-2 transition-all"
        >
          <FaSave />
          Simpan Register Obat
        </button>
      </div>
      <Toaster
        position="top-right"
      />
    </div>
  );
};

export default RegisterObat;
